<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card flat>
        <v-radio-group v-model="limitType" mandatory hide-details class="ma-0">
          <v-radio :label="$t('ManageHourLimitQr.noLimit')" value="noLimit" />
          <v-radio :label="$t('ManageHourLimitQr.dateLimit')" value="date" />

          <v-expand-transition>
            <v-row no-gutters v-if="limitType === 'date'" class="my-2">
              <v-col cols="12" md="6" class="pa-2">
                <custom-date-picker
                  v-model="date.date"
                  :label="$t('ManageHourLimitQr.startDate')"
                  outlined
                  dense
                  append-icon="mdi-calendar-month"
                  :min="nowDateTimeString()"
                  hide-details
                  :key="$i18n.locale + '-start-date'"
                  :sp="'/'"
                />
              </v-col>

              <v-col cols="12" md="6" class="pa-2">
                <div class="rowinfo">
                  <custom-date-picker
                    v-model="date.date_end"
                    :label="$t('ManageHourLimitQr.endDate')"
                    outlined
                    dense
                    clear-icon="mdi-close-circle-outline"
                    append-icon="mdi-calendar-month"
                    input-class="date-end"
                    :min="formatSpecificDate(date.date)"
                    hide-details
                    :key="$i18n.locale + '-end-date'"
                    :sp="'/'"
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-date-date_end`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('ManageHourLimitQr.endDate')"
                  />
                </div>
              </v-col>
            </v-row>
          </v-expand-transition>

          <v-radio :label="$t('ManageHourLimitQr.timeLimit')" value="time" />

          <v-expand-transition>
            <v-row no-gutters v-if="limitType === 'time'" class="my-2">
              <v-col cols="12" md="6" class="pa-2">
                <div class="rowinfo">
                  <custom-date-picker
                    v-model="date.date"
                    :label="$t('ManageHourLimitQr.selectDate')"
                    outlined
                    dense
                    class="contentinfo"
                    append-icon="mdi-calendar-month"
                    :min="nowDateTimeString()"
                    format="date"
                    hide-details
                    :key="$i18n.locale + '-date-date'"
                    :sp="'/'"
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-date-date`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('ManageHourLimitQr.selectDate')"
                  />
                </div>
              </v-col>

              <v-col cols="6" v-show="$vuetify.breakpoint.mdAndUp" />

              <v-col cols="12" md="6" class="pa-2">
                <div class="rowinfo">
                  <custom-date-picker
                    v-model="date.start"
                    :label="$t('ManageHourLimitQr.startTime')"
                    outlined
                    dense
                    input-class="start-hour"
                    hide-details
                    append-icon="mdi-clock-outline"
                    format="time"
                    :min="startMin"
                    :key="$i18n.locale + 'time-date-start'"
                    :sp="'/'"
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-date-start`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('ManageHourLimitQr.startTime')"
                  />
                </div>
              </v-col>

              <v-col cols="12" md="6" class="pa-2" v-if="rerender">
                <div class="rowinfo">
                  <custom-date-picker
                    v-model="date.end"
                    :label="$t('ManageHourLimitQr.endTime')"
                    outlined
                    dense
                    class="contentinfo"
                    input-class="end-hour"
                    hide-details
                    append-icon="mdi-clock-time-eleven-outline"
                    format="time"
                    :min="date.start"
                    :key="$i18n.locale + '-time-date-end'"
                    :sp="'/'"
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-date-end`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('ManageHourLimitQr.endTime')"
                  />
                </div>
              </v-col>
            </v-row>
          </v-expand-transition>
        </v-radio-group>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import CustomDatePicker from "../../../../content/custom-date-picker";
import moment from "moment-jalaali";

export default {
  name: "ManageHourLimitQr",

  components: { CustomDatePicker },

  props: {
    value: Object,
    data: Object,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "manger-hour-limitQr",
      date: {
        date: this.value?.activated_at || this.nowDateTimeString(),
        date_end: this.value?.deactivated_at || this.nowDateTimeString(),
        start: this.value?.activated_at
          ? this.getHour(this.value.activated_at)
          : this.nowDateTimeString("-", "time"),
        end: this.value?.deactivated_at
          ? this.getHour(this.value.deactivated_at)
          : this.nowDateTimeString("-", "time"),
      },
      isAfter: false,
      rerender: true,
      limitType: "noLimit",
    };
  },

  computed: {
    startMin() {
      return this.isAfter ? null : this.nowDateTimeString("-", "time");
    },
  },

  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    isAfter(val) {
      if (!val) {
        this.date.start = this.nowDateTimeString("-", "time");
        this.date.end = this.nowDateTimeString("-", "time");
      }
    },
    "date.date"(val) {
      let today = moment().format("YYYY-MM-DD");
      this.isAfter = moment(val).isAfter(today, "day");
      if (moment(this.date.date_end).isBefore(this.date.date, "day")) {
        this.date.date_end = val;
      }
    },
    "date.start"(val) {
      this.rerender = false;
      this.$nextTick(() => {
        this.rerender = true;
        setTimeout(() => {
          this.date.end = this.date.start;
        }, 100);
      });
    },
    date: {
      deep: true,
      handler(val) {
        let obj;
        if (this.limitType === "date") {
          obj = {
            activated_at: val.date,
            deactivated_at: val.date_end,
          };
        } else if (this.limitType === "time") {
          obj = {
            activated_at:
              this.getDate(val.date) + " " + this.getHour(val.start),
            deactivated_at:
              this.getDate(val.date) + " " + this.getHour(val.end),
          };
        }
        this.$emit("input", obj);
      },
    },
    limitType(val) {
      if (val === "noLimit") {
        this.value.activated_at = "";
        this.value.deactivated_at = "";
        this.$emit("input", { activated_at: null, deactivated_at: null });
        this.$forceUpdate();
      } else if (val === "date") {
        this.value.activated_at = this.date.date;
        this.value.deactivated_at = this.date.date_end;
      } else if (val === "time") {
        this.value.activated_at =
          this.getDate(this.date.date) + " " + this.getHour(this.date.start);
        this.value.deactivated_at =
          this.getDate(this.date.date) + " " + this.getHour(this.date.end);
      }
    },
    value: {
      handler(val) {
        if (val && val.activated_at) {
          const startDate = String(val.activated_at).split(" ")[0];
          const endDate = val.deactivated_at
            ? String(val.deactivated_at).split(" ")[0]
            : "";

          if (startDate && endDate && startDate === endDate) {
            this.limitType = "time";
          } else {
            this.limitType = "date";
          }
        } else if (!val || !val.activated_at) {
          this.limitType = "noLimit";
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    formatSpecificDate(date, sp = "/", type = "datetime") {
      if (!date) return "";

      const parsedDate = moment(date);
      if (!parsedDate.isValid()) return date;
      if (type === "time") {
        return parsedDate.format("HH:mm");
      }

      if (this.$i18n.locale === "fa") {
        return type === "date"
          ? parsedDate.format(`jYYYY${sp}jMM${sp}jDD`)
          : parsedDate.format(`jYYYY${sp}jMM${sp}jDD HH:mm:ss`);
      } else {
        return type === "date"
          ? parsedDate.format(`YYYY${sp}MM${sp}DD`)
          : parsedDate.format(`YYYY${sp}MM${sp}DD HH:mm:ss`);
      }
    },
    nowDateTimeString(sp = "/", type = "datetime") {
      if (type === "time") {
        return moment().format("HH:mm");
      }

      if (this.$i18n.locale === "fa") {
        return type === "date"
          ? moment().format(`jYYYY${sp}jMM${sp}jDD`)
          : moment().format(`jYYYY${sp}jMM${sp}jDD HH:mm:ss`);
      } else {
        return type === "date"
          ? moment().format(`YYYY${sp}MM${sp}DD`)
          : moment().format(`YYYY${sp}MM${sp}DD HH:mm:ss`);
      }
    },
    getHour(input) {
      let str = input.split(" ");
      if (str.length > 1) {
        return str[1];
      }
      return str[0];
    },
    getDate(input) {
      return input.split(" ")[0];
    },
  },
};
</script>

<style scoped></style>
